export default __webpack_public_path__ + "static/media/blue_11_melon_diamond_crosseyed_smirk_cape.ff2683f4.png";